import Input from "../../Input"

const DeathRoomChannel = ({ values, serverData }) => {
    return (
        <div className="mx-14 h-full">
            <h6 className="flex justify-center">چنل اتاق مرگ</h6>
            <div className="mt-2">
                <Input
                    type="number"
                    name={`deathRoomChannel-id`}
                    label="ایدی چنل *"
                    placeholder="ChannelID"
                    options={serverData?.channelList}
                    autoComplete="off"
                    dir="ltr"
                    defaultValue={values?.id}
                />
            </div>
            <div className="mt-2">
                <Input
                    type="text"
                    name={`deathRoomChannel-ignoreSgList`}
                    label="رنک هایی که گرفته نشوند (با , جدا کنید)"
                    placeholder="1,2,3"
                    options={serverData?.sgList}
                    multi={true}
                    autoComplete="off"
                    dir="ltr"
                    defaultValue={values?.ignoreSgList}
                />
            </div>
            <div className="mt-2">
                <label>پیامی که هنگام ورود به چنل ارسال شود: *</label>
                <textarea
                    type="text"
                    name={`deathRoomChannel-msg`}
                    class="styled-input "
                    placeholder="با ارسال yes! تمام رنک های شما برداشته میشود و با no! میتوانید لغو کنید سی ثانیه فرصت دارید تا جواب بدید"
                    autoComplete="off"
                    dir="rtl"
                    defaultValue={values?.msg}
                />
            </div>
            <div className="mt-2">
                <Input
                    type="text"
                    name={`deathRoomChannel-kickMsg`}
                    label="دلیل کیک کاربر بعد از سی ثانیه بدون جواب:"
                    placeholder="Message"
                    autoComplete="off"
                    dir="ltr"
                    defaultValue={values?.kickMsg}
                />
            </div>
            <div className="mt-5 p-2 text-gray-400 border-gray-700 border rounded-md font-sans">
                <span>توضیحات:</span>
                <div dir="rtl" className="">
                    همه ی رنک های کسی که وارد چنل میشود گرفته میشود به جز رنک هایی که بالا تعیین میکنید
                </div>
            </div>
        </div>
    )
}

export default DeathRoomChannel
